<template>
  <div
    ref="video"
    class="c-video-player c-video-wrapper"
    :class="{ 'ma-auto': isReallyMobile }"
  >
    <video
      controlsList="nodownload noremoteplayback"
      controls
      preload="metadata"
      :poster="poster"
    >
      <source :src="url" type="video/mp4">
      {{ $t('notice.browser.videoNotSupported') }}
    </video>
  </div>
</template>

<script>
import mobileMixin from '@/mixins/mobileMixin.js'

export default {
  name: 'VideoPlayer',

  components: {},

  mixins: [mobileMixin],

  props: {
    content: {
      type: Object,
      required: true
    },

    fullscreen: {
      type: Boolean,
      required: false,
      default: false
    },

    params: {
      type: Object,
      required: false,
      default: () => {}
    }
  },

  data: function () {
    return {
      poster: this.content.thumbnail,
      url: this.content.contentURL,
      isFullscreen: false
    }
  },

  computed: {
    isReallyMobile() {
      return this.mobileMixin_isReallyMobile
    }
  },

  mounted: function () {
    this.$refs.video.addEventListener('fullscreenchange', this.onFullscreen)
    this.$refs.video.addEventListener('webkitfullscreenchange', this.onFullscreen)
  },

  beforeDestroy: function () {
    this.$refs.video.removeEventListener('fullscreenchange', this.onFullscreen)
    this.$refs.video.removeEventListener('webkitfullscreenchange', this.onFullscreen)
  },

  methods: {
    onFullscreen() {
      this.isFullscreen = !this.isFullscreen
    }
  }
}
</script>

<style lang="css" scoped>
.c-video-wrapper {
  position: relative;
  max-width: 100%;
  min-height: 200px;
  background-size: contain;
  aspect-ratio: 4 / 3;
  height: 100%;
}

video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
